import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

import HotelStockTable from '@com/hotel/HotelStockTable.vue';
import StatusBar from '@com/StatusBar.vue';
import { ref, reactive } from 'vue';
import { Search } from '@element-plus/icons-vue';
import useRoute from "@util/router";
import CategoryManager from '@com/CategoryManager.vue';
import $ from "@util/base";
import configApi from "@api/config";
import api from "@api/hotel";
export default {
  __name: 'HotelStockManager',

  setup(__props) {
    const route = useRoute();
    const categoryConfig = {
      type: 'hotel'
    };
    const baseOptions = ref([]);
    getConfig();

    function getConfig() {
      configApi.base(val => {
        baseOptions.value = val;
      });
    }

    const statusList = reactive([{
      label: '全部',
      value: 1,
      total: 0
    }, {
      label: '已上架',
      value: 3,
      total: 0
    }, {
      label: '已下架',
      value: 2,
      total: 0
    }]);
    const base = ref(route.query().base || '');
    const name = ref(route.query().name || '');

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    function searchBase(val) {
      route.replaceQuery('base', val);
    }

    function searchName(val) {
      route.replaceQuery('name', val);
    }

    function addGoods() {
      route.push('/goodsdetails');
    }

    function getExport() {
      let routeQuery = route.query();
      api.managerExport({
        categoryCode: routeQuery.c,
        shopCode: routeQuery.base,
        name: routeQuery.name,
        status: routeQuery.status
      }, val => {
        $.download(val.url, "酒店管理列表导出");
      });
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createBlock(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_main, {
          class: "base_main_content"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
            inline: true,
            class: "base_search_form",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: base.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => base.value = $event),
                onChange: searchBase,
                placeholder: "请选择基地",
                clearable: ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: name.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => name.value = $event),
                "onKeyup[native]": searchName,
                onChange: searchName,
                placeholder: "酒店名称",
                clearable: "",
                "suffix-icon": _unref(Search)
              }, null, 8, ["modelValue", "suffix-icon"])]),
              _: 1
            })]),
            _: 1
          })]), _createVNode(HotelStockTable, {
            type: "manager",
            route: "hotelmanager",
            onStatusData: statusData
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }

};